<template>
  <div id="visualizar-solicitacao" class="container container_com-fundo container_com-margem column dados-da-solicitacao borda">
    <div class="logos print has-text-centered">
      <img src="../../../assets/imagens/logo-relatorio-retrato.jpg" width="100%" alt="Logo AGEHAB/SEILOG">
    </div>

    <div class="espacamento-interno visualizar-solicitacao" v-if="!loading">
      <div class="field-body-linha">
        <h2
          class="titulo titulo_grande u-margem-esquerda-pequena title is-5 print titulo-relatorios">
          Solicitação de subsídio
        </h2>
        <h2
          class="titulo titulo_grande u-margem-inferior-pequena u-margem-esquerda-pequena title is-5 no-print titulo-relatorios">
          Solicitação de subsídio
        </h2>
        <button type="button" onclick="window.print()"
          class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio">
          <i class="fa fa-print" aria-hidden="true"></i>
          Imprimir
        </button>
      </div>
      <p class="texto-informativo u-margem-esquerda-pequena">
        <span class="valor">
         Solicitação de Aporte de subsídio para contratação de financiamento habitacional dentro do programa Emendas Cidades conforme Portaria AGEHAB/MS nº 206 de 08 de maio de 2024
        </span>
      </p>
      <div class="borda">
        <h2 class="titulo titulo_pequeno u-margem-inferior-media title is-5">
          Dados do Proponente
        </h2>
        <div v-for="(proponente, index) in proponentes">
          <span class="titulo titulo_pequeno">
            {{ index + 1 }}º Proponente
          </span>
          <div class="field is-horizontal">
            <div class="linha">
              <div class="field coluna">
                <span class="label">
                  <strong>Nome:</strong>
                </span>
                <span>{{ proponente.Nome }}</span>
              </div>
              <div class="field coluna">
                <span class="label">
                  <strong>CPF:</strong>
                </span>
                <span>{{ proponente.Cpf }}</span>
              </div>
              <div class="field coluna">
                <span class="label">
                  <strong>Telefone: </strong>
                </span>
                <span>{{ proponente.Telefone || 'NÃO INFORMADO' }}</span>
              </div>
            </div>
          </div>
          <div v-if="proponente.Conjuge">
            <span class="titulo titulo_pequeno">
              {{ index + 1 }}º Cônjuge
            </span>
            <div class="field is-horizontal">
              <div class="linha">
                <div class="field coluna">
                  <span class="label">
                    <strong>Nome:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Nome }}</span>
                </div>
                <div class="field coluna">
                  <span class="label">
                    <strong>CPF:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Cpf }}</span>
                </div>
                <div class="field coluna">
                  <span class="label">
                    <strong>Telefone: </strong>
                  </span>
                  <span>{{ proponente.Conjuge.Telefone || 'NÃO INFORMADO' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="field-body field-body-linha">
          <div class="field">
            <span class="label">
              <strong>Renda familiar comprovada:</strong>
            </span>
            <span><strong>{{ rendaTotalComprovada }}</strong></span>
          </div>
        </div>
      </div>      

      <div class="borda u-margem-inferior-gigante">
        <h2 class="titulo titulo_pequeno u-margem-inferior-media title is-5">
          Dados do Imóvel
        </h2>
        <div class="field is-horizontal">
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Construtora:</strong>
              </span>              
              <span>{{ imovel.Empreendimento.Construtora.Nome }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>CNPJ:</strong>
              </span>
              <span>{{ imovel.Empreendimento.Construtora.Cnpj }}</span>
            </div>
          </div>
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>APF:</strong>
              </span>
              <span>{{ imovel.Apf }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Conta vinculada:</strong>
              </span>
              <span>{{ imovel.Empreendimento.Construtora.Conta }}</span>
            </div>
          </div>
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Cidade:</strong>
              </span>
              
              <span>{{ imovel.Endereco.Cidade.Nome + ' - ' + imovel.Endereco.Cidade.EstadoSigla  }}</span>

            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Endereço:</strong>
              </span>
              <span>{{ imovel.Endereco.Logradouro + ", " + imovel.Endereco.NumeroDoImovel }}</span>
            </div>
          </div>
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>CEP:</strong>
              </span>
              <span>{{ imovel.Endereco.Cep }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Bairro/Complemento:</strong>
              </span>
              <span>{{ imovel.Endereco.Bairro }}, {{ imovel.Endereco.Complemento }}</span>
            </div>
          </div>
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Empreendimento:</strong>
              </span>
              <span>{{ imovel.Empreendimento.Nome }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Tipo de empreendimento:</strong>
              </span>
              <span>{{ imovel.Empreendimento.TipoDeEmpreendimento }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Valor de compra e venda:</strong>
              </span>
              <span>{{ valorDaCompraEVenda }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Valor do financiamento:</strong>
              </span>
              <span>{{ valorDoFinanciamentoAprovado }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Subsídio do Governo Federal:</strong>
              </span>
              <span>{{ subsidioDoGovernoFederal }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Subsídio da AGEHAB:</strong>
              </span>
              <span>{{ subsidioDaAgehab }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Desconto da construtora</strong>
              </span>
              <span>{{ descontoDaConstrutora }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Participação do proponente:</strong>
              </span>
              <span>{{ participacaoDoSolicitante }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Matrícula:</strong>
              </span>
              <span>{{ imovel.Matricula }}</span>
            </div>
          </div>
        </div>
      </div>      

      <router-link :to="{ name: 'ListaDeSolicitacoes'}"
          class="no-print botao botao_medio botao_cinza u-margem-direita-pequena"
          :class="{ 'is-disabled': loading.visivel }">Voltar
      </router-link>

    </div>
    <loading :ativo="loading" :altura="'60px'" :largura="'60px'" />
  </div>
</template>

<script>
import Loading from '../../shared/Loading';

export default {
  name: 'visualizar-solicitacao-mcmv',
  components: { Loading },
  filters: {
    upcase(data) {
      return data.toUpperCase();
    },
  },
  data() {
    return {
      mensagemDeErro: null,
      mensagemDeErroDoCancelamento: null,
      proponentes: [],
      usuarioSolicitanteNome: null,
      financiamento: {},
      imovel: {},
      rendaTotal: null,
      valorDaCompraEVenda: null,
      valorDoFinanciamentoAprovado: null,
      subsidioDaAgehab: null,
      subsidioDoGovernoFederal: null,
      descontoDaConstrutora: null,
      fgtsDoSolicitante: null,
      participacaoDoSolicitante: null,
      loading: true,
      status: null,
      justificativa: '',
    };
  },
  beforeCreate() {
    this.loading = true;
    const idDaSolicitacao = this.$route.query.idDaSolicitacao;

    this.$api.get(`/solicitacao/${idDaSolicitacao}`).then((response) => {
      const solicitacao = response.data;

      this.solicitante = solicitacao.Solicitante;
      this.proponentes = solicitacao.Proponentes;
      this.financiamento = solicitacao.Financiamento;
      this.imovel = solicitacao.Imovel;
      this.status = solicitacao.Status;
      this.usuarioSolicitanteNome = solicitacao.UsuarioSolicitanteNome;
      this.rendaTotal = this.$moeda.formatar(solicitacao.RendaTotal);
      this.valorDaCompraEVenda = this.$moeda.formatar(this.financiamento.ValorDaCompraEVenda);
      this.valorDoFinanciamentoAprovado = this.$moeda.formatar(this.financiamento.ValorDoFinanciamentoAprovado);
      this.subsidioDaAgehab = this.$moeda.formatar(this.financiamento.SubsidioDaAgehab);
      this.subsidioDoGovernoFederal = this.$moeda.formatar(this.financiamento.SubsidioDoGovernoFederal);
      this.fgtsDoSolicitante = this.$moeda.formatar(this.financiamento.FgtsDoSolicitante);
      this.participacaoDoSolicitante = this.$moeda.formatar(this.financiamento.ParticipacaoDoSolicitante);
      this.solicitacaoEhDoBonusMoradia = solicitacao.EhBonusMoradia;
      this.rendaTotalComprovada = this.$moeda.formatar(solicitacao.RendaTotalComprovada);
      this.descontoDaConstrutora =  this.$moeda.formatar(this.financiamento.DescontoConstrutora);
      this.loading = false;
    }).catch((error) => {
      console.error(error);
    });
  }
};
</script>



// WEBPACK FOOTER //
// VisualizarSolicitacaoMcmv.vue?3ba9ea54